
import Vue, {PropType} from "vue";
import {Form} from "@/api/types/Form";
import {Tenant} from "@/api/types/Tenant";

export default Vue.extend({
  name: "FormSettings",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {
          photoUrl: "",
          tenantIds: [] as string[]
        } as Partial<Form>
      }
    },
    tenantOptions: {
      type: Array as PropType<Array<Tenant>>,
      default: []
    },
  },
  data() {
    return {
      images: [
        "https://www.ctvnews.ca/polopoly_fs/1.1967522.1584700888!/httpImage/image.jpg_gen/derivatives/landscape_1020/image.jpg",
        "https://dlslab.com/wp-content/uploads/2020/12/covid-19-testing-centers-848x477.jpg",
        "https://www.tollgateclinic.com/wp-content/uploads/2013/04/tollgate14.jpg",
        "https://res.cloudinary.com/imap2/image/upload/c_fill,g_auto,h_630,q_auto:eco,w_1200/v1508233134/industries/industry-healthcare.jpg",
      ],
    }
  },
  methods: {
    getColFlex(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 3;
        case "xl":
          return 2;
        default:
          return 12;
      }
    },
  }
});
